import * as LabelPrimitive from "@radix-ui/react-label";
import { type VariantProps, cva } from "class-variance-authority";
import * as React from "react";

import { cn } from "@gettactic/helpers";

const labelVariants = cva("");

const Label = React.forwardRef<
  React.ComponentRef<typeof LabelPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> &
    VariantProps<typeof labelVariants> & {
      isInvalid?: boolean;
    }
>(({ className, isInvalid, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(
      labelVariants(),
      "flex w-full items-center justify-between space-x-2 text-secondary-foreground",
      isInvalid && "text-semantic-error-foreground",
      "form-field-label font-semibold text-[12px] text-neutral-900",
      className
    )}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
